// extracted by mini-css-extract-plugin
export default {"background":"InfoModal_background__IPy8k","modal":"InfoModal_modal__XlVe7","btn_main":"InfoModal_btn_main__ldPCe"};